import send from './send';
import { eventsKeys } from '../constants';

export default () => {
  send(eventsKeys.DOWNLOAD_PDF_FROM_POPUP);
};
